import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';

function Home() {
    return (
        <Container>
            {/* 自己紹介セクション */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Yohei Nishidate (Dr.)
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Senior Associate Professor
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Department of Computer Science and Engineering, University of Aizu
                </Typography>
                <Typography variant="body2" paragraph>
                    Tsuruga, Ikki-Machi, Aizu-Wakamatsu City, Fukushima 965-8580, Japan
                </Typography>
                <Typography variant="body2" paragraph>
                    <strong>Researchmap:</strong> <Link href="https://researchmap.jp/y-nishidate" target="_blank" rel="noopener noreferrer">y-nishidate</Link>
                </Typography>
            </Box>

            {/* Short Biography */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Short Biography
                </Typography>
                <Typography variant="body2" paragraph>
                    Yohei Nishidate is currently a Senior Associate Professor at the School of Computer Science and Engineering, The University of Aizu, Japan. 
                    He received his M.S. and Ph.D. degrees from The University of Aizu in 2006 and 2009 respectively. 
                    He was a Researcher of RIKEN, Volume-CAD project in 2009 to 2011.
                    He is a visiting researcher of RIKEN. 
                    He is a fellow of Kyoto Institute of Technology. 
                    His research interests include physics based modeling, simulation, and computational visualization.
                </Typography>
            </Box>

            {/* Google Formsの埋め込み */}
            <Box mb={4}>
                <Typography variant="h6" gutterBottom>
                    Contact Us
                </Typography>
                <Typography variant="body2" paragraph>
                    If you have any inquiries, please fill out the form below and we will get back to you shortly.
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        paddingBottom: '75%', // フォームの縦横比に応じて調整
                        height: 0,
                        overflow: 'hidden',
                        maxWidth: '100%',
                    }}
                >
                    <iframe
                        src="https://docs.google.com/forms/d/e/1FAIpQLScFknURlXntaBBNvoGEggC9qCTga0XzNIpwsRj4YX6DRVc-Xg/viewform?embedded=true" // your-form-idをGoogle FormsのIDに置き換える
                        width="100%"
                        height="100%"
                        style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                        allowFullScreen
                        title="Contact Form"
                    ></iframe>
                </Box>
            </Box>
        </Container>
    );
}

export default Home;
